import React from 'react';
import { Save, CheckCircle, AlertCircle } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';

const AutoSaveIndicator = ({ isSaving, lastSaved, error }) => {
  if (error) {
    return (
      <div className="flex items-center space-x-2 text-red-400 text-sm">
        <AlertCircle className="w-4 h-4 animate-pulse" />
        <span>Auto-save failed</span>
      </div>
    );
  }

  if (isSaving) {
    return (
      <div className="flex items-center space-x-2 text-yellow-400 text-sm">
        <Save className="w-4 h-4 animate-pulse" />
        <span>Saving draft...</span>
      </div>
    );
  }

  if (lastSaved) {
    return (
      <div className="flex items-center space-x-2 text-green-400 text-sm">
        <CheckCircle className="w-4 h-4" />
        <span>
          Draft saved {formatDistanceToNow(lastSaved, { addSuffix: true })}
        </span>
      </div>
    );
  }

  return null;
};

export default AutoSaveIndicator;